<ion-header>
  <ion-toolbar>
    <ion-title class="toolbar">Photo</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()" (keydown)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-img [src]="photoUrl"></ion-img>
</ion-content>
